import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_NEW_APPLICANTS';
export const single = 'SINGLE_NEW_APPLICANT';

export const listInterviews = 'LIST_NEW_APPLICANT_INTERVIEWS';
export const listResumes = 'LIST_NEW_APPLICANT_INTERVIEWS';
export const singleInterview = 'SINGLE_NEW_APPLICANT_INTERVIEW';

export const newApplicantsApi = createApi({
  reducerPath: 'newApplicantsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    updateApplicant: builder.mutation({
      query: ({ requisitionId: _, applicantId, ...attributes }) => ({
        url: `/requisitions/applicant/update/${applicantId}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ applicantId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedApplicant } = await queryFulfilled;
          dispatch(
            newApplicantsApi.util.updateQueryData('listApplicants', undefined, (draft) => {
              const applicant = draft.data.items.find((applicant) => applicant.id === applicantId);
              if (applicant) {
                const { firstName, lastName, email, phone, address, completedAt, statusChangedAt, status, reason } = updatedApplicant.data;
                Object.assign(applicant, { firstName, lastName, email, phone, address, completedAt, statusChangedAt, status, reason });
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    unarchiveApplicant: builder.mutation({
      query: (ids) => ({
        url: `/requisitions/applicant/unarchive`,
        method: 'POST',
        body: {
          ids
        }
      }),
      async onQueryStarted(ids, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            newApplicantsApi.util.updateQueryData('listApplicants', undefined, (draft) => {
              draft.data.items = draft.data.items.filter((item) => !ids.includes(item.id));
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getApplicantById: builder.query({
      query: (applicantId) => `/requisitions/applicant/get/${applicantId}`,
      providesTags: [single]
    }),
    listApplicants: builder.query({
      query: (params) => ({
        url: '/requisitions/applicant/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    }),
    exportApplicants: builder.query({
      query: (params) => ({
        url: '/requisitions/applicant/export',
        params: { ...params },
        responseHandler: (response) => response.text()
      })
    })
  })
});

export const {
  useUnarchiveApplicantMutation,
  useUpdateApplicantMutation,
  useGetApplicantByIdQuery,
  useListApplicantsQuery,
  useExportApplicantsQuery,
  useLazyExportApplicantsQuery
} = newApplicantsApi;
